import { absoluteUrl } from "./seo.js";

/**
 * @param {string | undefined | null} title
 */
export function slugifyShowcaseTitle(title) {
  return (
    String(title || "untitled")
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "photo"
  );
}

/**
 * @param {{ t?: string, title?: string } | string | undefined | null} photoOrTitle
 */
export function showcasePhotoSlug(photoOrTitle) {
  if (typeof photoOrTitle === "string") {
    return slugifyShowcaseTitle(photoOrTitle);
  }
  return slugifyShowcaseTitle(photoOrTitle?.t || photoOrTitle?.title);
}

/**
 * @param {string | number | { id?: string | number, t?: string, title?: string } | null | undefined} photoOrId
 * @param {string} [title]
 */
export function photographyShowcaseHref(photoOrId, title) {
  if (photoOrId === null || photoOrId === undefined || photoOrId === "") {
    return "/photography";
  }

  const id =
    typeof photoOrId === "object" ? photoOrId.id : photoOrId;
  const photoTitle =
    typeof photoOrId === "object"
      ? photoOrId.t || photoOrId.title
      : title;

  if (id === null || id === undefined || id === "") {
    return "/photography";
  }

  const slug = slugifyShowcaseTitle(photoTitle);
  const encodedId = encodeURIComponent(String(id));

  if (!photoTitle || slug === "photo" || slug === "untitled") {
    return `/photography/showcase/${encodedId}`;
  }

  return `/photography/showcase/${encodedId}/${slug}`;
}

/**
 * Branded OG image URL for a showcase photo (logo overlay, server-generated).
 *
 * @param {string | number} photoId
 * @param {"og" | "twitter"} [variant]
 */
export function showcaseOgImageUrl(photoId, variant = "og") {
  const id = encodeURIComponent(String(photoId));
  const query = variant === "twitter" ? "?variant=twitter" : "";
  return absoluteUrl(`/api/v1/og/showcase/${id}.jpg${query}`);
}
